import React from 'react';
import { render, screen, waitFor } from '@testing-library/react';
import userEvent from '@testing-library/user-event';

import { Button, Popover } from '../';

(window as any).ResizeObserver = class ResizeObserver {
	observe() {}
	disconnect() {}
};

const NestedPortalPopovers = () => {
	const PopoverButton = (props: any) => {
		const [open, setOpen] = React.useState(false);

		return (
			<Popover
				direction="r"
				onClickOutside={() => setOpen(false)}
				open={open}
				portal
				trigger={
					<Button
						el="span"
						onClick={() => setOpen(true)}
						className={props.className}
					>
						{props.text}
					</Button>
				}
			>
				<div className="d-ib">{props.children}</div>
			</Popover>
		);
	};

	return (
		<div className="d-ib">
			<PopoverButton className="btn1" text="Button1">
				<PopoverButton className="btn2" text="Button2">
					<PopoverButton className="btn3" text="Button3">
						<i>Test</i>. Most deeply nested popover.
					</PopoverButton>
				</PopoverButton>
			</PopoverButton>
			<Button className="btn0 m-y-1">Button</Button>
		</div>
	);
};

describe('test nested portaled Popovers for onClickOutside() suppression', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	const user = userEvent.setup();

	it('one nested popover should be closed per click', async () => {
		render(<NestedPortalPopovers />);
		const { queryByText: query } = screen;

		expect(query('Button')).not.toBeNull(); // Button which is outside all popovers
		expect(query('Button1')).not.toBeNull();
		expect(query('Button2')).toBeNull();
		expect(query('Button3')).toBeNull();
		expect(query('Test')).toBeNull(); // Element inside most deeply nested popover

		await user.click(query('Button1')); // Open popover1
		await waitFor(() => {});
		expect(query('Button2')).not.toBeNull(); // Popover1 is open
		expect(query('Button3')).toBeNull();

		await user.click(query('Button2')); // Open popover2
		await waitFor(() => {});
		expect(query('Button3')).not.toBeNull(); // Popover2 is open
		expect(query('Test')).toBeNull();

		await user.click(query('Button3')); // Open popover3
		await waitFor(() => {});
		expect(query('Test')).not.toBeNull(); // Popover3 is open

		await user.click(query('Button')); // Should close popover3 only
		await waitFor(() => {});
		expect(query('Button1')).not.toBeNull();
		expect(query('Button2')).not.toBeNull();
		expect(query('Button3')).not.toBeNull();
		expect(query('Test2')).toBeNull(); // Popover3 is closed

		await user.click(query('Button')); // Should close popover2 only
		await waitFor(() => {});
		expect(query('Button1')).not.toBeNull();
		expect(query('Button2')).not.toBeNull();
		expect(query('Button3')).toBeNull(); // Test popover2 is closed
		expect(query('Test')).toBeNull();

		await user.click(query('Button')); // Should close popover1 only
		await waitFor(() => {});
		expect(query('Button1')).not.toBeNull();
		expect(query('Button2')).toBeNull(); // Popover1 is closed
		expect(query('Button3')).toBeNull();
		expect(query('Test')).toBeNull();
	});
});

describe('Popover', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Popover
				portal
				popperClassName="popperClassName"
				open
				direction="br"
				trigger={<Button>Toggle Popover</Button>}
				data-auto-sel="automation-selector"
			>
				This is a Popover
			</Popover>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});

	it('should pass data automation attributes to portal', () => {
		const { container, baseElement } = render(
			<Popover
				portal
				popperClassName="popperClassName"
				open
				direction="br"
				trigger={<Button>Toggle Popover</Button>}
				portalDataAttributes={{
					'data-auto-sel': 'automation-selector',
				}}
			>
				This is a Popover
			</Popover>
		);

		const nonPortalElement = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);
		const portalElement = baseElement.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(nonPortalElement).toBeNull();
		expect(portalElement).not.toBeNull();
	});
});
